import {Domain} from '../../domains/domain';

export class Department {
    public id?: string;
    public name: string;
    public domain?: Domain;
}
